"use client";

import {
  checkIfAdminDashboardEntitiesExists,
  isTemplateActive,
  templatesForAdminDashboard,
} from "@/services/template.service";
import { useMemo } from "react";
import { useEntitiesFromDb } from "@/hooks/schema/use-entities-from-db";

export const useAdminFeaturesExist = () => {
  const { entities } = useEntitiesFromDb();

  const adminExists = useMemo(() => checkIfAdminDashboardEntitiesExists(entities), [entities]);

  const isLoading = !entities;

  const allAdminFeaturesExist = useMemo(() => {
    if (!adminExists || isLoading) {
      return false;
    }

    // Every required feature must match its declaration in full. Opt-in features
    // never block this gate.
    return templatesForAdminDashboard
      .filter((template) => !template.optional)
      .every((template) => isTemplateActive(adminExists.templateResults?.[template.entityName]));
  }, [adminExists, isLoading]);

  return {
    adminExists,
    allAdminFeaturesExist,
    isLoading,
  };
};
